import type { CmsPageCollectionItems, CmsCarModelItem } from '$cms/types';

interface LinkObject {
  readonly name: string;
  readonly link: string;
}

export function makePopularModelLink(
  pageCollectionItems: CmsPageCollectionItems,
  collectionItem: Pick<CmsCarModelItem, 'name' | 'slug' | 'make'>
): LinkObject {
  const { product } = pageCollectionItems;
  const { name: modelName, slug: modelSlug, make } = collectionItem;
  const name = [make.name, modelName].filter(Boolean).join(' ');
  let link = `/${make.slug}/${modelSlug}`;

  if (product) {
    link = `/${product.slug}/${make.slug}/${modelSlug}`;
  }
  return {
    name,
    link,
  };
}
